import {EnvironmentAdmin} from 'compob2b-libs';

export class EnvironmentAdminProd extends EnvironmentAdmin {
  production = true;
  serviceWorkers = true;
  enableWorkflowButton = false;
  serverPicturesPath = 'https://prod.lim-holding.compo-soft.ru/pictures';
  serverDocumentsPath = 'https://prod.lim-holding.compo-soft.ru/documents';
  serverDamDocumentsPath = 'https://prod.lim-holding.compo-soft.ru/dam-documents';
  serverApi =  'https://prod.lim-holding.compo-soft.ru/api/v1';
  serverUrl =  'https://prod.lim-holding.compo-soft.ru';
  impersonate = false;
  accessRolesCatalog = true;
}

export const environment = new EnvironmentAdminProd();
